import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpEvent, HttpHandler, HttpRequest, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { Router } from '@angular/router';
import { catchError } from 'rxjs/operators';
import { AuthService } from './authentication.service';
import { environment } from 'src/environments/environment';

export class HttpError {
  static BadRequest = 400;
  static Unauthorized = 401;
  static Forbidden = 403;
  static NotFound = 404;
  static TimeOut = 408;
  static Conflict = 409;
  static InternalServerError = 500;
}

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  handledError: number[] = [401];

  constructor(private router: Router, private authService: AuthService) {}

  /**
   * Gestion des erreur HTTP des appel vers le web-service et redirection vers la page de gestion des erreurs
   * @param  {HttpRequest<unknown>} req
   * @param  {HttpHandler} next
   * @returns Observable
   */
  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const logFormat = 'background: maroon; color: white';
    return next.handle(req).pipe(
      // tap({
      //   // Succeeds when there is a response; ignore other events
      //   next: (event) => (ok = event instanceof HttpResponse ? 'succeeded' : ''),
      //   // Operation failed; error is an HttpErrorResponse
      // }),
      catchError(response => {
        if (req.url.startsWith(environment.apiUxUrl) === false) {
          return throwError(response);
        }

        if (response instanceof HttpErrorResponse) {
          if (this.handledError.indexOf(response.status) > -1) {
            this.authService.login();
          }
        }

        if (response instanceof HttpErrorResponse) {
          switch (response.status) {
            case HttpError.BadRequest:
              console.error('%c Bad Request 400', logFormat);
              break;

            case HttpError.Unauthorized:
              console.error('%c Unauthorized 401', logFormat);
              window.location.reload();
              break;

            case HttpError.NotFound:
              //show error toast message
              console.error('%c Not Found 404', logFormat);
              // const _toaster = this._injector.get(Toaster),
              //     _router = this._injector.get(Router);
              // _toaster.show({
              //     message: exception.error && exception.error.message ? exception.error.message :
              //         exception.statusText,
              //     typeId: 'error',
              //     isDismissable: true
              // });
              // _router.navigate(['']);
              break;

            case HttpError.TimeOut:
              // Handled in AnalyticsExceptionHandler
              console.error('%c TimeOut 408', logFormat);
              break;

            case HttpError.Forbidden:
              console.error('%c Forbidden 403', logFormat);
              // const _authService = this._injector.get(AuthorizationService);
              // _authService.showForbiddenModal();
              break;

            case HttpError.InternalServerError:
              console.error('%c Error 500', logFormat);
              break;
          }
        }
        return throwError(response);
      })
    );
  }
}
